import { type FC, useState } from "react";
import { usePartnerMetrics } from "@/hooks/usePartnerMetrics";
import { MetricsCards } from "./components/MetricsCards";
import { PartnersList } from "./PartnersList";
import { Input } from "@/components/ui/input";
import { Search, Users2Icon } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PartnersManagement: FC = () => {
  const { partners, summaryMetrics, loading, refreshMetrics } = usePartnerMetrics();
  const [searchQuery, setSearchQuery] = useState("");

  const filteredPartners = partners.filter(partner => 
    partner.display_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    partner.email?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <div className="flex flex-col md:flex-row md:items-center justify-end gap-4 mb-6 md:mb-8">
        <Button
          variant="outline"
          size="sm"
          onClick={refreshMetrics}
          disabled={loading}
        >
          Actualizar
        </Button>
      </div>

      <div className="space-y-6">
        {/* Metrics */}
        <MetricsCards metrics={summaryMetrics} loading={loading} />
        
        {/* Search */}
        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <div className="relative flex-1 w-full">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <Input
              placeholder="Buscar socios..."
              className="pl-10 w-full"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        {/* Partners List */}
        <div className="rounded-md border bg-card">
          <PartnersList
            partners={filteredPartners}
            loading={loading}
            onRefresh={refreshMetrics}
          />
        </div>
      </div>
    </>
  );
};
